import {scaleOrdinal} from 'd3-scale';
import Default from '../default/';

function _scale() {
  const scale = this.scale();
  const munged = this.__execs__.munged;
  let regionDomain = Default.ordinalDomain(munged, 0, d => d.data.key, this.__execs__.field.region.order); 
  scale.color = scaleOrdinal().domain(regionDomain).range(this.color());
}

export default _scale;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/pie/_scale.js